'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _Component = require('../Component');

var _Component2 = _interopRequireDefault(_Component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactisInputs = require('reactis-inputs');

var _components = {
	_$ActiveSelect: {
		displayName: 'ActiveSelect'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var ActiveSelect = (function (_Component) {
	_inherits(ActiveSelect, _Component);

	function ActiveSelect() {
		_classCallCheck(this, _ActiveSelect);

		_Component.apply(this, arguments);
	}

	ActiveSelect.prototype.render = function render() {

		var options = [{ id: 1, title: 'Aktivní' }, { id: 2, title: 'Archiv' }, { id: 3, title: 'Vše' }];

		return _react2['default'].createElement(_reactisInputs.Select, _extends({}, this.props, {
			style: { width: 100, display: 'block' },
			clearable: false,
			options: options
		}));
	};

	var _ActiveSelect = ActiveSelect;
	ActiveSelect = _wrapComponent('_$ActiveSelect')(ActiveSelect) || ActiveSelect;
	return ActiveSelect;
})(_Component2['default']);

exports['default'] = ActiveSelect;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Form/ActiveSelect.js
 ** module id = 165
 ** module chunks = 2
 **/